module.exports = __webpack_public_path__ + "img/img8.bc21ee27.png";